import React, {useContext, useState} from 'react';
import {useArticleFinder} from "./useArticleFinder";
import {CategoryContext} from "./CategoryContext";
import {BusyContainer} from "./BusyContainer";
import classNames from "classnames";
import {SearchInput} from "./SearchInput";
import {ShowArticle} from "./ShowArticle";
import {Link} from "react-router-dom";
import {useDeepLink} from "../util/utilites";

interface ArticleProps {
    setPageSize: ( pageSize: number ) => void;
    setCurrentPage: ( currentPage: number ) => void;
}

export const ArticlePane: React.FunctionComponent<ArticleProps> = ({ setCurrentPage, setPageSize }) => {
    const {loading, articles = [], error} = useArticleFinder();
    const {currentPage = 0, pageSize = 100, article} = useContext(CategoryContext);
    const [selectedArticle, setSelectedArticle] = useState(article);
    const [getDeepLink] = useDeepLink();

    const onSelection = (e: React.MouseEvent<HTMLAnchorElement>, articleId: number): void => {
        const articlePane = document.querySelector('.article');
        if (articlePane) {
            articlePane.classList.add('slideout');
            setTimeout(() => {
                setSelectedArticle( selectedArticle === articleId ? -1 : articleId );
            }, 500 );
            return;
        }
        setSelectedArticle(articleId);
    };

    const scrollIntoViewWhenSelected = (e: HTMLAnchorElement | null ) => {
        if (!e) {
            return;
        }
        if (!e.classList.contains("selected")) {
            return;
        }
        // slight delay (hopefully enough to load the article)
        setTimeout(() => {
            e.scrollIntoView({
                behavior: 'smooth'
            });
        }, 300 );
    }

    return (
        <>
            { error && <div className="error">{ error }</div> }
            <div className="table">
                <div className="header">
                    <div className="col-xs-1"></div>
                    <div className="col-xs-1">CODE</div>
                    <div className="col-xs-7">OMSCHRIJVING</div>
                    <div className="col-xs-1">GEWICHT</div>
                    <div className="col-xs-1">STENEN</div>
                    <div className="col-xs-1">KARAAT</div>
                </div>
            </div>
            <div className="flex-grid table">
                { articles && articles.map( (art, c) => (<>
                    <Link ref={e => scrollIntoViewWhenSelected(e)} to={`/${getDeepLink( { article: art.Id === selectedArticle ? -1 : art.Id } )}`} className={classNames('row', { 'even': c % 2 === 0, 'uneven': c % 2 === 1, 'selected': art.Id === selectedArticle })} key={`${art.Id}-${selectedArticle}`} onClick={e => onSelection(e, art.Id)}>
                        <div className="col-xs-1">{ art.HasPicture ? '📷' : ''}</div>
                        <div className="col-xs-1">{ art.Code.toLocaleUpperCase() }</div>
                        <div className="col-xs-7">{ art.Description }</div>
                        <div className="col-xs-1">{ art.Weight ? art.Weight : '' }</div>
                        <div className="col-xs-1">{ art.Length ? art.Length : '' }</div>
                        <div className="col-xs-1">{ art.CaratName }</div>
                    </Link>
                    { selectedArticle === art.Id && <ShowArticle id={art.Id}/> }
                </>))}
                { loading && <BusyContainer text="Loading" /> }
            </div>
            <div className="pages">
                <div className="col-xs-3">
                    <button className="tool-button" type="button" onClick={ () => setCurrentPage( 0 ) } disabled={ currentPage === 0}>⏮</button>
                    <button className="tool-button" type="button" onClick={ () => setCurrentPage( currentPage - 1 )} disabled={currentPage === 0}>⏪</button>
                    <span>Pagina: { currentPage + 1 }</span>
                </div>
                <div className="col-xs-6">
                    <SearchInput />
                </div>
                <div className="col-xs-3 right">
                    <button className="tool-button" type="button" onClick={ () => setCurrentPage( currentPage + 1 )} disabled={articles.length < pageSize}>⏩</button>
                    <span>Aantal per pagina:</span>
                    <select onChange={ e => setPageSize( Number(e.currentTarget.value ) )} value={pageSize}>
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={250}>250</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                    </select>
                </div>
            </div>
        </>
    );
};